import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { cards } from 'sections/Benefits/ShippingLeads/data';
import Card from 'components/Card';
import styles from 'styles/pages/Benefits/ShippingLeads/ShippingLeads.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  const cardsList = cards.map((card) => {
    return (
      <Card className={cn('card')} key={card.icon}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img src={`/images/pages/Benefits/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card__title')}>{card.title}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('cards')}>
      <div className={cn('container')}>
        <div className={cn('cards__title-box')}>
          <h2 className={cn('cards__title')}>
            <span>Why Shipping Leads are Your Gateway to Growth</span>
          </h2>
          <p className={cn('cards__title-description')}>
            Discover how tapping into a steady flow of shipping leads can transform your freight
            business, elevate your market presence, and boost profitability.
          </p>
        </div>
        <ul className={cn('cards__list')}>
          {cardsList}
        </ul>
      </div>
    </section>
  );
}

export default SectionPitch;